import { makeStyles } from 'tss-react/mui';
import { spacing } from '../../styles/jss/variables';
const useStyles = makeStyles()((theme) => ({
    modal: {
        '& header': {
            [theme.breakpoints.up('md')]: {
                paddingLeft: '50px',
            },
            [theme.breakpoints.up('lg')]: {
                paddingLeft: '72px',
            },
            [theme.breakpoints.up('xl')]: {
                paddingLeft: '104px',
            },
            '& h3': Object.assign(Object.assign({}, theme.typography.small_regular), { [theme.breakpoints.up('md')]: Object.assign({}, theme.typography.large_regular) }),
        },
        '& .MuiDialogContent-root': {
            '& p': Object.assign({}, theme.typography.small_regular),
        },
        '& .MuiDialog-paper': {
            padding: '20px',
            [theme.breakpoints.up('md')]: {
                padding: spacing.large,
            },
        },
    },
    container: {
        [theme.breakpoints.up('md')]: {
            paddingLeft: '50px',
            paddingRight: '50px',
        },
        [theme.breakpoints.up('lg')]: {
            paddingLeft: '72px',
            paddingRight: '72px',
        },
        [theme.breakpoints.up('xl')]: {
            paddingLeft: '104px',
            paddingRight: '104px',
        },
    },
    buttonContainer: {
        display: 'flex',
        flexDirection: 'column-reverse',
        flexFlow: 'column reverse',
        [theme.breakpoints.up('md')]: {
            flexDirection: 'row',
            justifyContent: 'space-between',
            paddingTop: spacing.small,
        },
        '& button': {
            [theme.breakpoints.down('md')]: {
                margin: `${spacing.xs} 0`,
            },
            marginBottom: spacing.small,
        },
        '& button:not(:first-child)': {
            [theme.breakpoints.up('md')]: {
                marginLeft: spacing.small,
            },
        },
    },
}));
export default useStyles;
